/**
 * Optional direct posthog-js access for web. App analytics use PostHogProvider + usePostHog only —
 * do not call initPostHogWeb from the app (would duplicate network traffic vs the provider client).
 */

import posthog, { type PostHog } from 'posthog-js'
import { logger } from '../helpers/logger.helper'
import { getAnalyticsEnvironment } from './environment.helper'

let client: PostHog | null = null

export function initPostHogWeb(apiKey: string, host?: string): void {
  logger.debug('[Analytics] initPostHogWeb', { hasClient: !!client, apiKeyPresent: !!apiKey })
  if (client) return
  if (!apiKey) {
    logger.debug('[Analytics] initPostHogWeb SKIP: no apiKey')
    return
  }
  client = posthog.init(apiKey, {
    api_host: host || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    disable_surveys: true,
  })
  client.register({ environment: getAnalyticsEnvironment() })
  logger.debug('[Analytics] PostHog ready', {
    environment: getAnalyticsEnvironment(),
    host: host || 'https://eu.i.posthog.com',
  })
}

export function getPostHogClientWeb(): PostHog | null {
  return client
}

export function isPostHogWebInitialized(): boolean {
  return client !== null
}
